<template lang="pug">
  div
    active-item
      .dropdown(:class="{active: active}" slot-scope="{ setActive, active }"  v-click-outside="() => setActive(false)")
        .dropdown__btn(@click.prevent="setActive(!active)")
          span(class="align-middle leadding-10") {{ label }}
          mark(class="inline-flex items-center justify-center md:hidden ml-2" v-if="selectedValues.length")
            | {{ selectedValues.length }}
        fade-transition
          .dropdown__menu(class="px-6 pt-10 pb-12 md:min-w-350p" v-show="active")
            div(class="mb-8") Combien de chambre ?
            div(class="flex items-center lg:justify-between")
              p-check(class="p-default" :key="value" v-model="selectedValues" :value="value" v-for="value in values")
                | {{ value }}
</template>

<script>
export default {
  props: {
    initialBedrooms: {
      type: Array,
      default: () => {
        return []
      }
    }
  },

  data () {
    return {
      selectedValues: [],
      values: ["1", "2", "3", "4", "5+"],
      label: 'Nb de chambres'
    }
  },

  watch: {
    selectedValues () {
      this.$store.commit('updateParams', { key: 'by_bedrooms', value: this.selectedValues })

      this.$store.dispatch('searchAccommodations')
        .then(({ bedroomsLabel }) => {
          this.label = bedroomsLabel
        })
    }
  },

  mounted () {
    this.selectedValues = [...this.initialBedrooms]

    this.$nextTick(() => {
      this.$store.commit('updateReady', 'bedroomsCheckboxes')
    })
  }
}
</script>
